module.exports = __webpack_public_path__ + "static/media/Gallery-16.152116ba.jpg";